module.exports = __webpack_public_path__ + "media/src/images/pdf-d516dc25d7fe7f43cc78dd0ea49585fa.png";